import React from 'react';
import { Icon } from '@chargify/icons';
import { BodyText, Column, Row, Toggle, Tooltip } from '../../../atoms';
import { ToggleVariant } from '../../../atoms/Toggle/types';
import { ContentWrapper, ToggleWrapper } from './OnOffComponent.styles';

export type OnOffProps = {
  name: string;
  isOn?: boolean;
  isDisabled?: boolean;
  description?: string;
  toggleVariant?: ToggleVariant;
};
const OnOffComponent = ({
  isOn,
  isDisabled,
  name,
  description,
  toggleVariant = 'reversed',
}: OnOffProps) => {
  return (
    <Row>
      <Column span={20}>
        <ContentWrapper gridGap={2}>
          <BodyText
            overflow="truncate"
            variant="body2"
            color={'gray.dark'}
            fontWeight={2}
          >
            {name}
          </BodyText>
          {description && (
            <Tooltip
              renderContent={() => <Tooltip.Text message={description} />}
              placement="top-start"
              followCursor
            >
              <Icon type={'questionCircle'} fill={'gray.dark'} size={16} />
            </Tooltip>
          )}
        </ContentWrapper>
      </Column>
      <Column span={4}>
        <ToggleWrapper>
          <Toggle isDisabled={isDisabled} variant={toggleVariant} isOn={isOn} />
        </ToggleWrapper>
      </Column>
    </Row>
  );
};
export default OnOffComponent;
